module.exports = __webpack_public_path__ + "img/SummaryBannerMobile.152c30aa.svg";